import * as d3 from 'd3'

// d3总共会tick 300次
// const totalTimes = 300

export default function simulation(
  nodes: any,
  links: any,
  animate: boolean,
  tickCb?: (nodes: any) => void,
  endCb?: any,
  nodeDistance: number = 40,
  nodeR: number = 40,
  linkDistance: number = 330,
) {
  const force = d3
    .forceSimulation()
    .nodes(nodes)
    // 节点间距
    .force('collide', d3.forceCollide(nodeDistance + nodeR))
    .force('charge', d3.forceManyBody())
    .force(
      'link',
      d3
        .forceLink(links)
        .id((d: any) => d.id)
        .distance(nodeR * 2 + linkDistance),
    )
    .stop()

  const timer = setInterval(() => {
    for (let i = 0; i < 5; i++) {
      force.tick()
    }
    if (tickCb) {
      tickCb(force.nodes())
    }
  }, 10)
  // 每60个节点，渲染5s
  const time = 5000
  const timer2 = setTimeout(() => {
    clearInterval(timer)
    if (endCb) {
      endCb()
    }
  }, time)
  return {
    stop: () => {
      force.stop()
      clearTimeout(timer2)
      clearInterval(timer)
      if (endCb) {
        endCb()
      }
    },
  }
}
